import Icon from '../components/Icon.vue'

Icon.register({
  microscope: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M160 320c-17.7 0-32-14.3-32-32v-224c0-17.7 14.3-32 32-32v-16c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v16c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32h-12v16c0 8.8-7.2 16-16 16h-40c-8.8 0-16-7.2-16-16v-16h-12zM464 448c26.5 0 48 21.5 48 48 0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16 0-26.5 21.5-48 48-48h272c70.6 0 128-57.4 128-128s-57.4-128-128-128v-64c105.9 0 192 86.1 192 192 0 49.2-18.8 94-49.3 128h1.3zM104 416c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/microscope.js
// module id = 1570
// module chunks = 0